import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPlans } from "../../../services";
import errorService from "../../../services/errorService";
import { notification } from "antd";
import { client } from "../../../libs/client";



export const initializePlans = createAsyncThunk(
  "plans/initializePlans",
  async (region, { rejectWithValue }) => {
    try {
      const { data } = await getAllPlans(region);
      return data?.plans || data;
    } catch (error) {
      errorService.handleApiError(error, {
        component: "MyPlans",
        action: "initializePlans",
        showNotification: true,
      });
      return rejectWithValue(
        error.response?.data?.message || "Failed to load plans",
      );
    }
  },
);

export const selectPlanAndProceed = createAsyncThunk(
  "plans/selectPlanAndProceed",
  async (planId, { rejectWithValue }) => {
    try {
      const { data } = await client.post("/plans/upgrade", { planId });

      if (data?.requiresPayment && !data?.paymentUrl) {
        notification.info({
          message: "Payment required",
          description: "Redirecting you to payment to complete the upgrade.",
          placement: "topRight",
        });
      }
      return { planId, meta: data };
    } catch (error) {
      errorService.handleApiError(error, {
        component: "MyPlans",
        action: "selectPlanAndProceed",
        showNotification: true,
      });
      return rejectWithValue(error.response?.data?.message || "Upgrade failed");
    }
  },
);

// Async thunk to upgrade a plan (initiates backend change and prepares payment)
export const upgradePlan = createAsyncThunk(
  "plans/upgradePlan",
  async (planId, { rejectWithValue }) => {
    try {
      // Post to backend to initiate plan change; backend should validate and (optionally) return payment info
      await client.post("/plans/upgrade", { planId });
      return planId;
    } catch (error) {
      // Log and surface a friendly message
      errorService.handleApiError(error, {
        component: "MyPlans",
        action: "upgradePlan",
        showNotification: true,
      });
      return rejectWithValue(error.response?.data?.message || "Upgrade failed");
    }
  },
);

export const fetchPlanFeatures = createAsyncThunk(
  "plans/fetchPlanFeatures",
  async (planId, { rejectWithValue }) => {
    try {
      const payload = await client.get(`/plans/${planId}/features`);
      const features = payload?.features ?? payload;
      return { planId, features };
    } catch (error) {
      errorService.handleApiError(error, {
        component: "MyPlans",
        action: "fetchPlanFeatures",
        showNotification: true,
      });
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch plan features",
      );
    }
  },
);
